import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TranslatedToastrService {

  constructor(
    private toastrService: ToastrService,
    private translationService: TranslateService
  ) {}

  public showSuccessMessage(messageKey: string, params?: any): void {
    this.toastrService.success(this.translationService.instant(messageKey, params));
  }

  public showErrorMessage(messageKey: string, params?: any): void {
    this.toastrService.error(this.translationService.instant(messageKey, params));
  }
}
